module.exports = __webpack_public_path__ + "img/hieda no akyuu.664f7c3d.png";